/* eslint-disable eqeqeq */
/* eslint-disable no-console */
import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateHome } from "../../../Redux/Slices/home.slice";

const ItemBody17 = ({ notification }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleAcceptRequest = () => {
    dispatch(updateHome({ key: "notificationPopupVisible", value: false }));
    navigate("/rentals");
  };

  return (
    <div>
      <p className="font-poppins text-xs font-light text-black">
        <span className="font-medium text-primary capitalize">
          {notification?.metaData?.receiverHubName}{" "}
        </span>
        is requesting batteries for a rental trip ID{" "}
        <span className="font-medium">{notification?.metaData?.rentalId}.</span>{" "}
        Do you want to accept?
      </p>

      {/* if action is performed, do not show the button */}
      {notification?.metaData?.action == 1 ? null : (
        <div className="mt-1 w-full flex items-center gap-x-2">
          <button
            type="button"
            className="flex-1 bg-primary hover:bg-primary-50 py-2 px-4 text-center rounded-md"
            onClick={handleAcceptRequest}
          >
            <p className="font-poppins text-xs font-medium text-background-white">
              Accept Request
            </p>
          </button>
        </div>
      )}
    </div>
  );
};

export default ItemBody17;
